import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { RESEARCH } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/research/$id")({
  component: () => <DeptContentForm cfg={RESEARCH} id={Route.useParams().id} />,
});
